/* eslint-disable */
import $ from 'jquery';
import lazy from 'jquery-lazy';
import {
  jarallax,
  jarallaxElement,
  jarallaxVideo
} from 'jarallax';
import 'jquery-lazy';
/* eslint-enable */

export default function () {

  let jQueryBridget = require('jquery-bridget');

  jQueryBridget('jarallax', jarallax, $);

  $('.jarallax').jarallax({
    speed: 0.2
  });

  $('.truncated-block').readmore({
    speed: 75,
    lessLink: '<a href="#" class="btn btn-link lime-green-color bold">Read less</a>',
    moreLink: '<a href="#" class="btn btn-link lime-green-color bold">Read more</a>',
  });

  $('.lazy').lazy({
    // called before an elements gets handled
    beforeLoad(element) {
      const backgroundX = element.data('focus-x');
      const backgroundY = element.data('focus-y');
      const result = String(`${backgroundX} ${backgroundY}`);
      element.css('background-position', result);
    },
    effect: 'fadeIn',
    effectTime: 1000,
    threshold: 0
  });

  $('.phone-link').text(function () {
    $(this).replaceWith(
        `<a class="phone-link" href="tel:${$(this).text().replace(/-/g, '').replace(/ /g, '')
            .replace(/\./g, '')}">${$(this).text()}</a>`,
    );
  });

  const $hamburger = $('.hamburger');
  $hamburger.on('click', () => {
    $hamburger.toggleClass('is-active');
  });


  $(document).ready(function(){
    // Add minus icon for collapse element which is open by default
    $(".collapse.show").each(function(){
      $(this).prev(".question").find(".fa").addClass("fa-minus").removeClass("fa-plus");
    });

    // Toggle plus minus icon on show hide of collapse element
    $(".collapse").on('show.bs.collapse', function(){
      $(this).prev(".question").find(".fa").removeClass("fa-plus").addClass("fa-minus");
    }).on('hide.bs.collapse', function(){
      $(this).prev(".question").find(".fa").removeClass("fa-minus").addClass("fa-plus");
    });
  });

}
